import {
    DeliveryStoreCookiesRepository,
    DeliveryStoreCookiesRepositorySpec,
    SessionCookiesRepository,
    SessionCookiesRepositorySpec,
    ShopperTokenRepository,
    ShopperTokenRepositorySpec,
    StorageRepository,
    StorageRepositorySpec,
    UserCookiesRepository,
    UserCookiesRepositorySpec,
    UserSessionRepository,
    UserSessionRepositorySpec,
} from '@headless-workspace/core-domain';
import { RequestStrategy } from '@headless-workspace/data';
import { IsomorphicLogger, Logger } from '@headless-workspace/utils';
import {
    BasketRepository,
    BasketRepositorySpec,
    BookingConfigRepository,
    BookingConfigRepositorySpec,
    CatalogCategoriesRepository,
    CatalogCategoriesRepositorySpec,
    ContentAssetsRepository,
    ContentAssetsRepositorySpec,
    CrossBorderRepository,
    CrossBorderRepositorySpec,
    CustomerRepository,
    CustomerRepositorySpec,
    DeliveryToStoreRepository,
    DeliveryToStoreRepositorySpec,
    FooterSlotsRepository,
    FooterSlotsRepositorySpec,
    FreeShippingPriceRepository,
    FreeShippingPriceRepositorySpec,
    LocalitiesConfigRepository,
    LocalitiesConfigRepositorySpec,
    LoyaltyConfigsRepository,
    LoyaltyConfigsRepositorySpec,
    ModerationTermsRepository,
    NotifyMeRepository,
    NotifyMeRepositorySpec,
    OmnibusInformationsRepository,
    OmnibusInformationsRepositorySpec,
    PersistentBannerSlotRepository,
    PersistentBannerSlotRepositorySpec,
    PriceLegalMentionsRepository,
    PriceLegalMentionsRepositorySpec,
    ProductDetailSlotsRepository,
    ProductDetailSlotsSpec,
    ProductFormRepository,
    ProductsRepository,
    ProductsRepositorySpec,
    PromoStandardTextRepository,
    PromoStandardTextRepositorySpec,
    RedDotRepository,
    RedDotRepositorySpec,
    SearchGeolocationRepository,
    SearchGeolocationRepositorySpec,
    SearchRepository,
    SearchRepositorySpec,
    ShopTheFutureRepository,
    ShopTheFutureRepositorySpec,
    StoreRepository,
    StoreRepositorySpec,
    VipBrandsRepository,
    VipBrandsRepositorySpec,
    WishlistRepository,
    WishlistRepositorySpec,
} from '../../src';
import { Target2SellConfigRepository, Target2SellConfigRepositorySpec } from '../server/lib/config/target2Sell';
import {
    RecommendedProductsRepository,
    RecommendedProductsRepositorySpec,
} from '../server/lib/products/recommendations';

export const BasketRepositoryType = 'BasketRepository';
export const CatalogCategoriesRepositoryType = 'CatalogCategoriesRepository';
export const ContentAssetsRepositoryType = 'ContentAssetsRepository';
export const CrossBorderRepositoryType = 'CrossBorderRepository';
export const CustomerRepositoryType = 'CustomerRepository';
export const DeliveryStoreCookieRepositoryType = 'DeliveryStoreCookieRepository';
export const DeliveryToStoreRepositoryType = 'DeliveryToStoreRepository';
export const FooterSlotsRepositoryType = 'FooterSlotsRepository';
export const FreeShippingPriceRepositoryType = 'FreeShippingPriceRepository';
export const LoggerType = 'Logger';
export const NotifyMeRepositoryType = 'NotifyMeRepository';
export const LoyaltyConfigsRepositoryType = 'LoyaltyConfigsRepository';
export const OmnibusInformationsRepositoryType = 'OmnibusInformationsRepository';
export const PersistentBannerSlotRepositoryType = 'PersistentBannerSlotRepository';
export const PriceLegalMentionsRepositoryType = 'PriceLegalMentionsRepository';
export const ProductDetailSlotsRepositoryType = 'ProductDetailSlotsRepositoryType';
export const RecommendedProductsRepositoryType = 'RecommendedProductsRepository';
export const ProductsRepositoryType = 'ProductsRepository';
export const PromoStandardTextRepositoryType = 'PromoStandardTextRepository';
export const RedDotRepositoryType = 'RedDotRepository';
export const SearchGeolocationRepositoryType = 'SearchGeolocationRepository';
export const SearchRepositoryType = 'SearchRepository';
export const SessionCookiesRepositoryType = 'SessionCookiesRepository';
export const ShopperTokenRepositoryType = 'ShopperTokenRepository';
export const StorageRepositoryType = 'StorageRepository';
export const StoreRepositoryType = 'StoreRepository';
export const Target2SellConfigRepositoryType = 'Target2SellConfigRepository';
export const UserCookiesRepositoryType = 'UserCookiesRepository';
export const UserSessionRepositoryType = 'UserSessionRepository';
export const VipBrandsRepositoryType = 'VipBrandsRepository';
export const WishlistRepositoryType = 'WishlistRepository';
export const LocalitiesConfigRepositoryType = 'LocalitiesConfigRepository';
export const BookingConfigRepositoryType = 'BookingConfigRepository';
export const ShopTheFutureRepositoryType = 'ShopTheFutureRepository';
export const ProductFormRepositoryType = 'ProductFormRepository';
export const ModerationTermsRepositoryType = 'ModerationTermsRepository';

export const deps = () => ({
    [BasketRepositoryType]: BasketRepository as new (requestStrategy: RequestStrategy) => BasketRepositorySpec,
    [CatalogCategoriesRepositoryType]: CatalogCategoriesRepository as new () => CatalogCategoriesRepositorySpec,
    [ContentAssetsRepositoryType]: ContentAssetsRepository as new () => ContentAssetsRepositorySpec,
    [CrossBorderRepositoryType]: CrossBorderRepository as new () => CrossBorderRepositorySpec,
    [CustomerRepositoryType]: CustomerRepository as new (requestStrategy: RequestStrategy) => CustomerRepositorySpec,
    [DeliveryToStoreRepositoryType]: DeliveryToStoreRepository as new () => DeliveryToStoreRepositorySpec,
    [DeliveryStoreCookieRepositoryType]: DeliveryStoreCookiesRepository as new () => DeliveryStoreCookiesRepositorySpec,
    [FooterSlotsRepositoryType]: FooterSlotsRepository as new () => FooterSlotsRepositorySpec,
    [FreeShippingPriceRepositoryType]: FreeShippingPriceRepository as new () => FreeShippingPriceRepositorySpec,
    [LoggerType]: IsomorphicLogger as new () => Logger,
    [LoyaltyConfigsRepositoryType]: LoyaltyConfigsRepository as new () => LoyaltyConfigsRepositorySpec,
    [NotifyMeRepositoryType]: NotifyMeRepository as new () => NotifyMeRepositorySpec,
    [OmnibusInformationsRepositoryType]: OmnibusInformationsRepository as new () => OmnibusInformationsRepositorySpec,
    [PersistentBannerSlotRepositoryType]:
        PersistentBannerSlotRepository as new () => PersistentBannerSlotRepositorySpec,
    [PriceLegalMentionsRepositoryType]: PriceLegalMentionsRepository as new () => PriceLegalMentionsRepositorySpec,
    [ProductDetailSlotsRepositoryType]: ProductDetailSlotsRepository as new () => ProductDetailSlotsSpec,
    [RecommendedProductsRepositoryType]: RecommendedProductsRepository as new () => RecommendedProductsRepositorySpec,
    [ProductsRepositoryType]: ProductsRepository as new () => ProductsRepositorySpec,
    [PromoStandardTextRepositoryType]: PromoStandardTextRepository as new () => PromoStandardTextRepositorySpec,
    [RedDotRepositoryType]: RedDotRepository as new () => RedDotRepositorySpec,
    [SearchGeolocationRepositoryType]: SearchGeolocationRepository as new (
        apiBaseUrl: string,
    ) => SearchGeolocationRepositorySpec,
    [SearchRepositoryType]: SearchRepository as new () => SearchRepositorySpec,
    [SessionCookiesRepositoryType]: SessionCookiesRepository as new (
        requestStrategy: RequestStrategy,
    ) => SessionCookiesRepositorySpec,
    [ShopperTokenRepositoryType]: ShopperTokenRepository as new () => ShopperTokenRepositorySpec,
    [StorageRepositoryType]: StorageRepository as new () => StorageRepositorySpec,
    [StoreRepositoryType]: StoreRepository as new () => StoreRepositorySpec,
    [Target2SellConfigRepositoryType]: Target2SellConfigRepository as new () => Target2SellConfigRepositorySpec,
    [UserCookiesRepositoryType]: UserCookiesRepository as new () => UserCookiesRepositorySpec,
    [UserSessionRepositoryType]: UserSessionRepository as new () => UserSessionRepositorySpec,
    [VipBrandsRepositoryType]: VipBrandsRepository as new () => VipBrandsRepositorySpec,
    [WishlistRepositoryType]: WishlistRepository as new (requestStrategy: RequestStrategy) => WishlistRepositorySpec,
    [LocalitiesConfigRepositoryType]: LocalitiesConfigRepository as new () => LocalitiesConfigRepositorySpec,
    [BookingConfigRepositoryType]: BookingConfigRepository as new () => BookingConfigRepositorySpec,
    [ShopTheFutureRepositoryType]: ShopTheFutureRepository as new () => ShopTheFutureRepositorySpec,
    [ProductFormRepositoryType]: ProductFormRepository as new () => ProductFormRepository,
    [ModerationTermsRepositoryType]: ModerationTermsRepository as new () => ModerationTermsRepository,
});
